import Collection from './collection.js';
import MtdLimit from 'newModels/mtd-limit.js';

export default class MtdLimits extends Collection {
    url() {
        if (this.payrollItem) {
            return `${this.payrollItem.url()}/mtdLimits`;
        }

        return '/MtdLimits';
    }

    initialize(models, {payrollItem = null}) {
        super.initialize(...arguments);
        this.model = MtdLimit;
        this.payrollItem = payrollItem;
        this.pagination = false;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/mtd-limits.js